<div class="listing-wrapper">
  <div class="listing-body" [class.filter-top]="filterPosition === 'top'" [class.filter-left]="filterPosition === 'left'"
    [class.without-filter]="!showFilterPanel">
    <aside *ngIf="showFilterPanel" class="listing-filter-panel">
      <ng-content select="[filter]"></ng-content>
    </aside>

    <main class="listing-content-panel">
      <ng-content select="[content]"></ng-content>
    </main>
  </div>
</div>
